
import Component from 'vue-class-component'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'

import ErrorHandler from '@/services/ErrorHandlerService'
import { INotificationService } from '@/services/NotificationService'

import { Extra } from '../../models/user'

import ExtrasService from '../../services/ExtrasService'

import AccountForm from './AccountForm.vue'

import BlueButton from '../Atomic/BlueButton.vue'
import GreenButton from '../Atomic/GreenButton.vue'
import RedButton from '../Atomic/RedButton.vue'
import CardTitle from '@/components/Atomic/CardTitle.vue'
import moment from 'moment'
import ProgressLinear from '@/components/Atomic/ProgressLinear.vue'

@Component({
  components: {
    AccountForm,
    BlueButton,
    GreenButton,
    RedButton,
    CardTitle,
    ProgressLinear,
  },
})
export default class UpdateExtra extends Vue {
  @Prop(Function) public readonly onClose!: () => void
  @Prop() public pending !: boolean
  @Prop() private readonly extras!: Extra[]

  private dialog: boolean = false
  private isPending: boolean = false

  private errorHandler = new ErrorHandler()
  private $notificationService!: INotificationService

  private title = ['Monsieur', 'Madame']

  @Prop() private readonly account!: Extra

  private mounted() {
    this.setDefaultBirthDate()
  }

  private setDefaultBirthDate() {
    if (this.account.date_naissance === undefined) {
      this.account.date_naissance = moment(new Date()).format('YYYY-MM-DD')
    }
  }

    private async updateAccount() {
    this.isPending = true
    const validated = await this.$validator.validateAll()
    if (validated) {
      try {
        await ExtrasService.update(this.account, this.account.personne_id)
        this.$notificationService.success(
          this.$t('EXTRAS.UpdateSuccess').toString(),
        )
        this.hide()
      } catch (error: any) {
        this.errorHandler.handle(this, error.response.data.code, true)
      }
    }
    this.isPending = false
  }

  private hide() {
    this.$validator.reset()
    this.onClose()
    this.dialog = false
  }
 }
